export default async function GetCascadeFromPlansApi(
  performanceCycle,
  positionId
) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/plans/cascaded-top-level-plans?performanceCycle=${performanceCycle}&positionId=${positionId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error getting cascade from plans: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }
  return res;
}
